export default __webpack_public_path__ + "static/media/wave-tablet.c5ec56e6.svg";